import { CSSProperties, useEffect } from 'react';
import { hapticFeedbackNotificationOccurred } from '@telegram-apps/sdk-react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import CloseShape from '@/components/common/svg/shapes/CloseShape.tsx';
import { notificationContainerStyles } from '@/components/Toast/components/styles';
import { SystemNotificationProps } from '@/components/Toast/components/types/notification.interface.ts';
import InfoShape from '@/components/common/svg/shapes/InfoShape.tsx';

const SystemNotification = ({ type, msg }: SystemNotificationProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (type === 'success') {
      toast.dismiss();
    }

    if (type !== 'info') {
      hapticFeedbackNotificationOccurred(type);
    }
  }, [type]);

  if (type === 'success') {
    return null;
  }

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        {type === 'error' && (
          <CloseShape width={16} height={16} fillColor="#FFF" strokeWidth={3} />
        )}
        {type === 'info' && (
          <InfoShape width={16} height={16} fillColor="#FFF" strokeWidth={3} />
        )}
      </div>
      <p style={textStyles}>{msg ? t(msg) : t('toast.system.unknown_error')}</p>
    </div>
  );
};

const containerStyles: CSSProperties = {
  ...notificationContainerStyles,
  borderRadius: '8px',
  background: '#282828',
  padding: '0px',
  display: 'flex',
  justifyContent: 'normal',
  alignItems: 'center',
  border: 'none'
};

const contentStyles: CSSProperties = {
  border: '2px solid #FFF',
  borderRadius: '15px',
  marginLeft: '13px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const textStyles: CSSProperties = {
  fontSize: '14px',
  color: '#FFF'
};

export default SystemNotification;
